<cmv-generic-content
	contentTitle="Verificación"
	btnText="Continuar"
	(clickEvent)="onContinuar()">
	<cmv-enter-code
		*ngIf="applicantPhoneAndIsApplicantAMember$ | async as dataForEnterCode"
		[phoneNumber]="dataForEnterCode.applicantPhone"
		[isMember]="dataForEnterCode.isApplicantAMember"
		[memberNumber]="dataForEnterCode.applicantId"
		(generateOtpSuccess)="onShowGeneratedOtpMessage($event)"
		(successEnterCode)="onSuccess($event)"
		(errorEnterCode)="onShowEnterCodeError($event)">
		<section after-resend>
			<div class="form-check mx-2 mb-0">
				<input
					type="checkbox"
					class="form-check-input"
					id="acceptGeographicalLocation"
					name="acceptGeographicalLocation"
					[(ngModel)]="acceptGeographicalLocationField"
					(change)="onHandleAcceptGeographicalLocationChange()"
					#acceptGeolocationInput />
				<label class="form-check-label" for="acceptGeographicalLocation"
					>Acepto el uso de mi ubicación geográfica y validación de datos de
					credencial para votar y comparación de biometría facial ante el INE
				</label>
			</div>
			<div class="mt-2" *ngIf="isAcceptGeographicalLocationErrorVisible">
				<div class="invalid-field text-danger font-14">
					Este campo es obligatorio
				</div>
			</div>
		</section>
	</cmv-enter-code>
</cmv-generic-content>
